import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const faqs = [
  { q: "What ages are your workshops for?", a: "Suitable for all ages — adults, teens, parents and children all welcome from age 8 upwards. Birthday packages are tailored to the guest of honour." },
  { q: "Do I need to bring anything?", a: "You're welcome to bring your own denim item to customise — a jacket, jeans, shorts, or a bag. If you'd like the studio to provide the denim, just let us know in advance with size, colour and the type of denim item you'd like. Tote bags and T-shirts are provided as part of the workshop options." },
  { q: "How big are the groups?", a: "Workshops are deliberately small — usually 6–12 attendees — so everyone gets one-to-one time with Miss Lolly." },
  { q: "Can you host a private party?", a: "Yes — pick a package on the Parties page or send a custom brief through the contact form." },
  { q: "Do you travel for events?", a: "For brand activations, school days and larger private events — yes. Get in touch with location, date and group size." },
  { q: "What's your cancellation policy?", a: "Re-bookings are free up to 7 days before a workshop. Deposits are non-refundable unless the workshop is cancelled by us." },
  { q: "Do you do adult-only sessions?", a: "Absolutely. Hen-dos, birthday brunches and creative team-building events are some of our favourites." },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page" className="bg-ink">
      <section className="container-x section-y">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <p className="overline">FAQ</p>
            <h1 className="mt-4 font-display text-6xl md:text-7xl text-white">
              Real <span className="text-rose">answers.</span>
            </h1>
            <p className="mt-6 text-white/75">
              Can't find what you need? <a href="/contact" className="text-gold underline-offset-4 hover:underline">Drop a message</a>.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="border-t-2 border-white/15" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`item-${i}`} className="border-b-2 border-white/15">
                  <AccordionTrigger data-testid={`faq-q-${i}`} className="py-6 text-left font-display text-2xl md:text-3xl uppercase text-white hover:no-underline hover:text-rose">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent data-testid={`faq-a-${i}`} className="text-white/75 text-base leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
}
